import React, { FC } from "react";

import { Text } from "@UI/Components/Text/Text";
import { RouterLink } from "@Libs/Router/Components/RouterLink/RouterLink";
import { FormattedMessage } from "@I18n/Components/FormattedMessage/FormattedMessage";

import messages from "./messages";

interface Props {
  showIban?: boolean;
  showCompanyName?: boolean;
  showYears?: boolean;
  showTermsAndConditionsLink?: boolean;
  showSitemapLink?: boolean;
}

export const Copyright: FC<Props> = ({
  showIban,
  showCompanyName,
  showYears,
  showTermsAndConditionsLink,
  showSitemapLink,
}) => {
  return (
    <Text fontSize="sm">
      {showYears && (
        <>
          <FormattedMessage {...messages.years} />

          {" - "}
        </>
      )}
      {showCompanyName && (
        <>
          <FormattedMessage {...messages.companyName} />
          {" - "}
        </>
      )}
      {showIban && (
        <>
          <FormattedMessage {...messages.iban} />
          {" - "}
        </>
      )}
      {showTermsAndConditionsLink && (
        <>
          <RouterLink
            route="TERMS_AND_CONDITIONS"
            fontSize="sm"
            textDecoration="underline"
          >
            <FormattedMessage {...messages.termsAndConditions} />
          </RouterLink>
          {" - "}
        </>
      )}
      {showSitemapLink && (
        <RouterLink route="SITEMAP" fontSize="sm" textDecoration="underline">
          <FormattedMessage {...messages.sitemap} />
        </RouterLink>
      )}
    </Text>
  );
};
